import { Box, Button, Flex, Heading, Text, Tooltip } from '@radix-ui/themes';
import type { CountryItem } from '@digiseg-labs/api-client';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import AudienceBuilderAnalysis from './AudienceBuilderAnalysis';
import type { ReachAnalysis, SankeyLink, SankeyNode, SelectedAudience } from './types';

type Props = {
  selectedAudiences: SelectedAudience[];
  analysis: ReachAnalysis;
  sankeyLinks: SankeyLink[];
  sankeyNodes?: SankeyNode[];
  selectedCountry: CountryItem | undefined;
  onRequest: () => void;
};

const AudienceBuilderSummary = ({
  selectedAudiences,
  analysis,
  sankeyLinks,
  sankeyNodes,
  selectedCountry,
  onRequest,
}: Props) => {
  const hasSelection = selectedAudiences.length > 0;
  const canRequest = hasSelection && !!selectedCountry;

  return (
    <Box className="builder-panel builder-panel--analysis">
      <Flex align="center" justify="between" gap="2" className="builder-summary-header">
        <Heading size="4">Reach Analysis</Heading>
        <Text size="2" className="builder-index">
          Audience Selection Index: <strong>{analysis.selectionIndex}</strong>
          <Tooltip content="Index 100 = Average Internet Population">
            <span className="builder-index-tooltip" aria-label="Index info">
              <InfoCircledIcon />
            </span>
          </Tooltip>
        </Text>
      </Flex>

      <AudienceBuilderAnalysis
        analysis={analysis}
        sankeyLinks={sankeyLinks}
        sankeyNodes={sankeyNodes}
        selectedCountry={selectedCountry}
      />

      {!selectedCountry && (
        <Text size="2" color="gray" className="builder-empty">
          Select a country to enable the request form.
        </Text>
      )}

      <Button
        size="3"
        className="fullwidth builder-request-button"
        onClick={onRequest}
        disabled={!canRequest}
      >
        Request Audience
      </Button>
    </Box>
  );
};

export default AudienceBuilderSummary;
